/***
 *
 *   TICKET CONTROLS STYLES
 *   Toolbar grid matches ui-reference ticket-toolbar.tsx.
 *
 **********/

const Style = {
    container: 'flex shrink-0 flex-col gap-2 border-b border-border pb-3',
    toolbar:
        'grid gap-3 [grid-template-columns:1fr_auto] sm:grid-cols-[auto_minmax(0,1fr)_auto] sm:items-center',
    toggleSlot: 'col-start-1 row-start-1 self-center',
    createBtn:
        'col-start-2 row-start-1 h-9 justify-self-end gap-1.5 self-center sm:col-start-3 sm:justify-self-auto',
    filtersSlot: 'col-span-2 row-start-2 min-w-0 sm:col-span-1 sm:row-start-1 sm:col-start-2',
    filtersRow: 'flex min-w-0 flex-wrap items-center gap-2',
    search: 'min-w-0 flex-1 sm:w-48 sm:flex-none',
    sortSelect: `h-9 appearance-none rounded-md border border-input bg-surface py-1 pl-8 pr-8 text-xs
    text-text-primary shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
    filterBtn: 'relative h-9 gap-2 px-3',
    chips: 'flex flex-wrap items-center gap-2',
};

export default Style;
